// extracted by mini-css-extract-plugin
export default {"tickle":"Tickle-module__tickle--s1hGI","copilotRun":"Tickle-module__copilotRun--zcx8E"};